import { z } from 'zod';
import { BlockSchema } from './Block.types';

import { CTABlockConfigSchema } from './blockConfig/Types';

export const CTABlockSchema = BlockSchema.extend({
  blockConfig: CTABlockConfigSchema,
});
export type CTABlock = z.infer<typeof CTABlockSchema>;
